import { render, staticRenderFns } from "./PaperView.vue?vue&type=template&id=69dec920&scoped=true&"
import script from "./PaperView.vue?vue&type=script&lang=js&"
export * from "./PaperView.vue?vue&type=script&lang=js&"
import style0 from "./PaperView.vue?vue&type=style&index=0&id=69dec920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dec920",
  null
  
)

export default component.exports